import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListFormBase } from '../../core/helper/ListFormBase';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { RecurringJobService } from '../../core/services/hangfire/recurringJobService.service';
import { RecurringJob } from '../../core/models/hangfireJobs/recurringJob.model';
import cronstrue from 'cronstrue/i18n';
import * as moment from 'moment';
import 'moment/locale/es'  // without this line it didn't work
moment.locale('es')

@Component({
  selector: 'app-proceso-list',
  templateUrl: './proceso-list.component.html',
  styleUrls: ['./proceso-list.component.scss'],
  providers: [RecurringJobService]
})
export class ProcesosListComponent extends ListFormBase<RecurringJob>
  implements AfterViewInit {

    // Propiedades del panel contenedor
  panelIcon = 'server'; // Material icon
  panelTitle = 'Procesos';
  panelDescription = 'Listado de los procesos de la aplicación';

  constructor(
    protected _modelService: RecurringJobService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog
  ) {
    super(_modelService, _router, _route, _messageDialog, RecurringJob);
    this.isCrud = true;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getDataSource('id');
    });
  }

  customizeTextCronExpression(cellInfo): string {
    if(cellInfo)
    {
        return cronstrue.toString(cellInfo.value, { locale: "es" });
    }

    return '';
  }

  customizeTextNextExecution(cellInfo): string {

    if(cellInfo)
    {
        return moment(cellInfo.value).fromNow();
    }

    return '';
  }

  customizeTextLastExecution(cellInfo): string {

    if(cellInfo)
    {
        return moment(cellInfo.value).fromNow();
    }

    return '';
  }

}
